import { Component, Input, OnInit } from '@angular/core';
import { BillingDto } from '../../../interfaces';
import { BILLING_STATUS } from '../../../enums';
import { BehaviorSubject } from 'rxjs';
import { differenceInDays } from 'date-fns/differenceInDays';
import { addDays } from 'date-fns/addDays';

@Component({
  selector: 'app-subscription-countdown',
  templateUrl: './subscription-countdown.component.html',
  styleUrl: './subscription-countdown.component.scss'
})
export class SubscriptionCountdownComponent implements OnInit {
  private readonly TRIAL_WARNING_LIMIT_DAYS = 3;
  private readonly GRACE_PERIOD_DURATION_DAYS = 3;
  protected color$ = new BehaviorSubject<'green' | 'red'>('green');

  @Input({ required: true }) billingInfo!: BillingDto;

  get isTrial(): boolean {
    return this.billingInfo.status === BILLING_STATUS.FREE_TRIAL;
  }

  get endDate() {
    if (this.billingInfo.status === BILLING_STATUS.FREE_TRIAL) {
      return new Date(this.billingInfo.trialEndAt);
    }

    if (this.billingInfo.status === BILLING_STATUS.PAST_DUE) {
      return addDays(new Date(this.billingInfo.nextPaymentDueAt), this.GRACE_PERIOD_DURATION_DAYS)
    }

    return new Date(this.billingInfo.nextPaymentDueAt);
  }

  ngOnInit(): void {
    this.color$.next(this.getColor());
  }

  getColor(): 'red' | 'green' {
    const now = new Date();
    const trialEndAt = new Date(this.billingInfo.trialEndAt);

    if (
      this.billingInfo.status === BILLING_STATUS.FREE_TRIAL &&
      differenceInDays(trialEndAt, now) <= this.TRIAL_WARNING_LIMIT_DAYS
    ) {
      // Trial is about to expire
      return 'red';
    }

    if (this.billingInfo.status === BILLING_STATUS.PAST_DUE || this.billingInfo.status === BILLING_STATUS.SUSPENDED) {
      // Subscription is overdue
      return 'red';
    }

    return 'green';
  }

  onUpdate() {
    this.color$.next(this.getColor());
  }
}
